import Swiper from 'swiper'
import { A11y, Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

/**
 * Gallery carousel — the project renders, one track.
 *
 * Whole numbers, not fractions: the track is unclipped (see base/carousel.css)
 * and runs off the right edge of the screen, so the slide that says "there is
 * more" is the one bleeding past the viewport rather than a part-slide sized to
 * sit inside the gutter. Two fill the container at desktop, one on a phone.
 *
 * `loop: false` is what lets the Navigation module mark itself disabled at the
 * first and last slide, which base/carousel.css styles the arrows against.
 */
export function initGalleryCarousel() {
    if (!document.querySelector('.gallery-images')) return

    new Swiper('.gallery-images', {
        modules: [A11y, Navigation, Pagination],
        slidesPerView: 1,
        // 24px is the page's spacing unit — the same gap sits under every
        // heading and between the year pills and their cards.
        spaceBetween: 24,
        loop: false,
        speed: 500,
        // The track is draggable but nothing about it says so on a desktop: the
        // arrows sit outside the cards, so the pointer is the only hint the row
        // itself can give. Swiper writes the grab/grabbing pair inline.
        grabCursor: true,
        breakpoints: {
            640: { slidesPerView: 2 },
        },
        navigation: {
            prevEl: '.gallery-prev',
            nextEl: '.gallery-next',
        },
        pagination: {
            el: '.gallery-pagination',
            clickable: true,
        },
        a11y: { containerMessage: 'Project gallery' },
    })
}
